module.exports = __webpack_public_path__ + "static/img/dyqr.a0d6271c.png";